<template>
    <div v-if="jsonViewStatus" class="fixed inset-0 z-50 flex flex-col bg-black bg-opacity-75">
        <div
            class="flex items-center justify-between bg-gradient-to-r from-gray-800 to-gray-700 text-white px-6 py-4 shadow-lg">
            <div class="flex items-center gap-3">
                <i class="fas fa-code text-orange-400"></i>
                <h3 class="text-lg font-bold">Form JSON Preview</h3>
            </div>
            <div class="flex gap-3">
                <!-- Copy Button with FontAwesome Icon -->
                <button
                    class="text-sm px-4 py-2 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors duration-200 flex items-center gap-2 shadow-sm"
                    @click="copyToClipboard">
                    <i class="fas fa-copy"></i> Copy JSON
                </button>
                <!-- Close Button with FontAwesome Icon -->
                <button
                    class="text-sm px-4 py-2 bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors duration-200 flex items-center gap-2 shadow-sm"
                    @click="closeModal">
                    <i class="fas fa-times"></i> Close
                </button>
            </div>
        </div>
        <div class="flex-grow overflow-auto bg-gray-900 p-6">
            <pre
                class="text-sm text-gray-200 bg-gray-800 p-6 rounded-lg border border-gray-600 shadow-inner overflow-x-auto">
                {{ JSON.stringify(formLayoutData, null, 2) }}
            </pre>
        </div>

        <!-- Toast Notification -->
        <div v-if="toastMessage" class="absolute bottom-4 right-4 bg-orange-600 text-white px-4 py-2 rounded shadow">
            {{ toastMessage }}
        </div>
    </div>
</template>
<script setup>
    import { ref, watchEffect } from 'vue';
    const toastMessage = ref(null);

    const props = defineProps({
        data: {
            type: Array,
            default: () => []
        },
        jsonViewStatus: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['update:jsonViewStatus']);

    const formLayoutData = ref(props.data || []);
    const localJsonViewStatus = ref(props.jsonViewStatus);

    // Watch for changes in props
    watchEffect(() => {
        formLayoutData.value = props.data || [];
        localJsonViewStatus.value = props.jsonViewStatus;
    });

    // Update parent when modal is closed
    const closeModal = () => {
        emit('update:jsonViewStatus', false);
    };

    const showToast = (message) => {
        toastMessage.value = message;
        setTimeout(() => {
            toastMessage.value = null; // Hide the toast after 3 seconds
        }, 3000);
    };

    const copyToClipboard = () => {
        const jsonContent = JSON.stringify(formLayoutData.value, null, 2);
        navigator.clipboard.writeText(jsonContent)
            .then(() => {
                showToast('JSON copied to clipboard!');
            })
            .catch((error) => {
                console.error('Failed to copy JSON:', error);
                showToast('Failed to copy JSON.');
            });
    };


</script>
